import { Form, Grid, Input, Panel, SingleColumnLayout } from '@salecycle/ui-component-library';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { updateStepValidityAction } from '../../actions';
import { useNewUserDispatch, useNewUserState } from '../../context/useNewUserContext';
import { fullNameValidCheck, emailValidCheck } from 'sections/user-management/utils/helpers';

export interface IProps {
  currentStep: number;
}

/* eslint-disable react-hooks/exhaustive-deps */
export const AddUserStep: React.FC<IProps> = ({ currentStep }: IProps) => {
  const { t } = useTranslation();
  const { validSteps, user } = useNewUserState();
  const dispatch = useNewUserDispatch();
  const [nameValid, setNameValid] = useState(fullNameValidCheck(user.name));
  const [nameTouched, setNameTouched] = useState(user.name.length !== 0);

  const [emailValid, setEmailValid] = useState(emailValidCheck(user.email));
  const [emailTouched, setEmailTouched] = useState(user.email.length !== 0);

  useEffect(() => {
    const valid = nameValid && emailValid;
    updateStepValidityAction(valid, validSteps, currentStep, dispatch);
  }, [nameValid, emailValid]);

  const handleNameChange = (value: string) => {
    setNameValid(fullNameValidCheck(value));

    if (nameTouched === false) {
      setNameTouched(true);
    }

    dispatch({ type: 'UPDATE_USER_NAME', payload: { name: value } });
  };

  const handleEmailChange = (value: string) => {
    setEmailValid(emailValidCheck(value));

    if (emailTouched === false) {
      setEmailTouched(true);
    }

    dispatch({ type: 'UPDATE_USER_EMAIL', payload: { email: value } });
  };

  return (
    <SingleColumnLayout paddingLeft={20} heading={t('newUser.addUserStep.heading')} showSidebar={false}>
      <Grid>
        <Panel heading={t('newUser.addUserStep.panelHeading')}>
          <Form>
            <Input
              label={t('newUser.addUserStep.fullName.label')}
              ariaLabel={t('newUser.addUserStep.fullName.label')}
              inputId="FullNameInput"
              placeholder={t('newUser.addUserStep.fullName.placeholder')}
              validationState={nameTouched && nameValid ? 'complete' : nameTouched ? 'warning' : null}
              validationMessage={nameTouched && !nameValid ? t('newUser.addUserStep.fullName.validation') : null}
              onChange={handleNameChange}
              value={user.name}
            />

            <Input
              label={t('newUser.addUserStep.email.label')}
              ariaLabel={t('newUser.addUserStep.email.label')}
              inputId="EmailInput"
              type="email"
              placeholder={t('newUser.addUserStep.email.placeholder')}
              validationState={emailTouched && emailValid ? 'complete' : emailTouched ? 'warning' : null}
              validationMessage={emailTouched && !emailValid ? t('newUser.addUserStep.email.validation') : null}
              onChange={handleEmailChange}
              value={user.email}
            />
          </Form>
        </Panel>
      </Grid>
    </SingleColumnLayout>
  );
};

export default AddUserStep;
